import React from 'react';
import './WordDetail.css'
import search from '../../images/搜索 (2)@2x.png';
import fetch from "isomorphic-fetch";
import BiShunCanvas from "./BiShunCanvas";
import PinyinSpeaker from "./PinyinSpeaker";
import BuShouSpeaker from "./BuShouSpeaker";
import CCPlayer from "./CCPlayer";
// import Videojs from "video.js";

export default class WordDetail extends React.Component {
    constructor(props) {
        super(props);
        this.getTextTimeouter = null;
        this.state = {
            //搜索数据
            words: [],
            //搜索的关键字
            text: '人',
            bushou: '',
            textInfo: null,
            //笔画数量
            bihuaCount: "",
            //笔顺
            bishun: "",
            //拼音
            pinyin: [],
            //汉字结构
            structure: "",
            //音频路径的前缀
            audioSrc: "",
            bishunColor: "#969696",
            //控制笔画结构的颜色
            controlIndex: -1,
            //是否显示笔顺
            isShowBishun: true,
            //偏旁部首是否是第一轮播放结束
            ifLast: false,
            //当前浏览器是否支持canvas  默认支持
            isSupportCanvas: true,
            //偏旁播放速度 默认1000毫秒
            bushouSpeed: 1000,

            current: 1,
            courseID: null,
            sectionID: null,
            videoUrl: null,
            videoLoading: false,
            loading: false,
        }
    };

    componentDidMount() {
        let {text} = this.state
        this.getTextDetailInfo(text);
        this.getBiShunData(text);
        this.getVideoUrl(text)
    }


    handChange = (e) => {
        this.setState({
            text: e.target.value,
        })
    }

    // 添加键盘事件处理函数
    handleKeyDown = (e) => {
        // 检测是否按下回车键 (keyCode 13)
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.handClick();
        }
    }

    //获取笔顺canvas动画数据
    getBiShunData = (text) => {
        let url = `//bishunfile.qiaoxuesi.com/${encodeURI(encodeURI(text))}/canvasData.json`;
        let that = this;
        fetch(url).then(
            function (response) {
                if (response.status !== 200) {
                    that.setState({isSupportCanvas: false})
                    return null;
                }
                //检查响应文本
                response.json().then(function (data) {
                    that.setState({textData: data, isShowBishun: true})
                });
            }
        ).catch(function (err) {
            console.log("Fetch错误:" + err);
        });
    }
    //获取汉字
    getTextDetailInfo = (text) => {
        //     ?random=${Math.floor(Math.random() * 10000000)}  添加随机数，避免缓存
        let url = `//bishunfile.qiaoxuesi.com/${encodeURI(encodeURI(text))}/bishun.json?random=${Math.floor(Math.random() * 10000000)}`;
        let _this = this;
        fetch(url).then(
            (response) => {
                if (response.status !== 200) {
                    return;
                }
                //检查响应文本
                response.json().then((data) => {
                    let {bihuaCount, bishun, bushou, pinyin, structure} = data;
                    let src = `//bishunfile.qiaoxuesi.com//${encodeURI(encodeURI(text))}/pinyin`
                    _this.setState({
                        words: data,
                        textInfo: data,
                        bihuaCount: bihuaCount,
                        bishun: bishun,
                        bushou: bushou,
                        pinyin: pinyin,
                        structure: structure,
                        currentText: text,
                        audioSrc: src,
                        controlIndex: -1,
                    })
                });

            }
        ).catch(function (err) {
            console.log("Fetch错误:" + err);
        });
    }

    //视频
    getVideoUrl = (text) => {
        let _this = this;
        _this.setState({videoLoading: false})
        fetch("https://www.gankao.com/api/video/playchinese", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                char: text
            })
        }).then((res) => {
            res.json().then(videoData => {
                if (videoData.status === 200) {
                    _this.setState({videoLoading: true})

                    // console.log(videoData.data.videoUrl.normal, '====12')
                    _this.setState({
                        // videoUrl: videoData.data.videoUrl.normal,
                        courseID: videoData.data.videoUrl.course_id,
                        sectionID: videoData.data.videoUrl.section_id
                    })
                    // ---
                    let newVideoPlayerUrl = null
                    // newVideoPlayerUrl=`https://www.gankao.com/ccplay_gankao_wrap?gkv=0.23&courseId=${videoData.data.videoUrl.course_id}&height=230px&m3u8_H=https%3A%2F%2Fvideo1.qiaoxuesi.com%2Fv_221008_162956lmFIKyRp_H.m3u8%3Fpm3u8%2F0%26e%3D1733400595%26token%3DnSqgk5YvwwprYlc-XT1qJcN_JwkKWHpNpCAci6kI%3AxDABYiRq6VJqn3YMb16j1kx27ZY%3D&m3u8_M=https%3A%2F%2Fvideo1.qiaoxuesi.com%2Fv_221008_162956lmFIKyRp_H.m3u8%3Fpm3u8%2F0%26e%3D1733400595%26token%3DnSqgk5YvwwprYlc-XT1qJcN_JwkKWHpNpCAci6kI%3AxDABYiRq6VJqn3YMb16j1kx27ZY%3D&nocover=1&parentNode=JYvideoPlayContainer&sectionId=571707&timestamp=1733378995&videoSource=qiniu&width=100%&vsign=b404ba45dae5ae87e997c51e0d64251c&hiddenFullscreenBt=1`
                    newVideoPlayerUrl = `https://www.gankao.com/ccplay_gankao_wrap?gkv=0.23&nocover=1&parentNode=videoplayer_container2&courseId=${videoData.data.videoUrl.course_id}&sectionId=${videoData.data.videoUrl.section_id}&width=100%&height=100%&videoSource=qiniu&m3u8_H=${encodeURIComponent(videoData.data.videoUrl.normal)}`
                    console.log(newVideoPlayerUrl, 'newVideoPlayerUrl====')


                    // 检查是否在原生应用中，如果是则添加隐藏全屏按钮参数
                    const userAgent = navigator.userAgent.toLowerCase();
                    const isGankaoHD = userAgent.indexOf('gankaohd') > -1;
                    const isFeishuo = userAgent.indexOf('feishuo') > -1;
                    
                    if (isGankaoHD || isFeishuo) {
                        // 为原生应用添加隐藏全屏按钮参数
                        newVideoPlayerUrl += '&hiddenFullscreenBt=1';
                    }

                    
                    _this.setState({
                        videoUrl: newVideoPlayerUrl,
                    })
                }
            });
        });

    }


    //点击搜索
    handClick = () => {
        let {text} = this.state;
        this.setState({
            textData: '',
            loading: true,
            ifLast: false,
            videoUrl: null
        })
        clearTimeout(this.getTextTimeouter);
        if (this.player) {
            this.player.dispose()
        }

        this.getTextTimeouter = setTimeout(() => {
            this.getTextDetailInfo(text);
            this.getBiShunData(text)
            this.getVideoUrl(text)
            this.setState({loading: false})
        }, 100)
    }
    //每个笔画开始的回调函数
    loop = ({loop}) => {
        let {controlIndex} = this.state
        if (loop) {
            this.setState({controlIndex: controlIndex + 1})
        } else {
            this.setState({controlIndex: -1, loop: false, ifLast: true})
        }
    }
    controlSpeed = (speed) => {
        let speedTemplate = ["fast", "normal", "slow"];
        let obj = {}
        switch (speed) {
            case "fast":
                obj.bushouSpeed = 1000;
                break;
            case "normal":
                obj.bushouSpeed = 1500;
                break;
            default:
                obj.bushouSpeed = 2000;
        }
        this.setState({obj})
        //

    }
    //canvas 创建失败
    canvasSupportError = (e) => {
        this.setState({isSupportCanvas: false, isShowBishun: false})
    }

    handOpenCourseVideo = (courseID, sectionID) => {
        window.JsBridgeApp.openCourseVideo(JSON.stringify({courseID: courseID, sectionID: sectionID, recommend: 1}));
    }

    render = () => {
        let {
            text, bushou, bihuaCount, structure, bishun, pinyin, audioSrc, isShowBishun, controlIndex,
            ifLast, videoUrl, textData, courseID, sectionID, videoLoading, loading
        } = this.state
        // console.log(videoUrl, 'videoUrl====', videoLoading)
        // console.log(textData, 'textData====kllll', )
        let arrBiShun = bishun.split(",");
        let HD = window.navigator.userAgent.indexOf('HD');
        let jif = "";
        if (text) {
            jif = `https://bishungif.qiaoxuesi.com/${encodeURI(encodeURI(text))}.gif-publish`
            // console.log(jif,'jjj')
        }

        // console.log(text,'text===',textData,'textData')
        return (
            <div>
                <div className="bookListBox">
                    <div className="searcher"
                        // onClick={this.handClick}
                    >
                        <input className="searcher-text"
                               placeholder="只能输入一个汉字....."
                               defaultValue={text}
                               onChange={this.handChange}
                               onKeyDown={this.handleKeyDown}/>
                        <img src={search} onClick={this.handClick}/>
                    </div>

                    {
                        text.length > 1 &&
                        <div style={{margin: '0 20px', color: 'red'}}>只能输入一个汉字!</div>
                    }
                    {
                        textData === '' && loading &&
                        <div style={{margin: '10px auto', padding: '15px', textAlign: 'center', color: '#417BEE', fontWeight: 'bold', }}>
                            加载中...
                        </div>
                    }
                    {
                        textData === '' && !loading &&
                        <div style={{margin: '0 20px', color: 'red',  textAlign: 'center'}}>暂无内容！</div>
                    }
                </div>
                {
                    (text.length > 1 || textData === '')
                        ? <div></div>
                        : <div className="bookListBox">
                            <div>
                                <div style={{display: 'flex', justifyContent: 'center'}}>
                                    {pinyin.length
                                        ? pinyin.map((item, index) =>
                                            <PinyinSpeaker
                                                audioSrc={audioSrc}
                                                key={"pinyinItem" + index} pinyin={item}
                                                index={index}/>)
                                        : ""}
                                </div>
                                <div>
                                    <div style={{textAlign: "center", position: "relative"}}>
                                        {textData ?
                                            <BiShunCanvas
                                                key={text}
                                                splitDelay={1000} // 笔画间隔时间
                                                splitCallback={this.loop} // 每画一笔的回调
                                                fillColor={'#417BEE'} // 笔画填充颜色
                                                crossColor={'#417BEE'} // 笔画轮廓颜色
                                                textFillColor={'#cad8e4'} // 文字填充颜色
                                                width={200} // 画布宽度
                                                canvasData={textData} // 笔顺数据
                                                isPlaying={true} // 自动播放笔顺
                                                failCallback={this.canvasSupportError}
                                                readStroke={true} // 读笔画
                                            /> : <div style={{width: "200px", margin: "20px auto"}}>
                                                <img style={{width: "100%"}} src={jif} alt=""/>
                                            </div>
                                        }
                                    </div>
                                    {/*{*/}
                                    {/*    !loading &&*/}
                                    <div style={{
                                        marginTop: "15px", display: "flex", justifyContent: "center",
                                        flexWrap: "wrap", width: "65%", margin: "0 auto 10px"
                                    }}>
                                        {(arrBiShun.length > 0)
                                            ? arrBiShun.map((item, index) => {
                                                // console.log(ifLast, 'ifLast====')
                                                let condition = controlIndex === index;
                                                let color = condition ? "green" : "#B4B4B4";
                                                return (<span
                                                    style={{color, marginRight: "5px"}}
                                                    key={"bishuns" + index}>
                                    {item}
                                                    {!ifLast && <BuShouSpeaker
                                                        controlIndex={controlIndex}
                                                        isCurrent={condition}
                                                        BuShou={item}/>}
                                        </span>)
                                            })
                                            : ""
                                        }
                                    </div>
                                    {/*}*/}

                                    <div className="controlSpeed">
                                        <div className="speedBtn" onClick={() => {
                                            this.controlSpeed("fast");
                                        }}>快
                                        </div>
                                        <div className="speedBtn" onClick={() => {
                                            this.controlSpeed("normal");
                                        }}>中
                                        </div>
                                        <div className="speedBtn" onClick={() => {
                                            this.controlSpeed("slow");
                                        }}>慢
                                        </div>
                                    </div>
                                </div>

                                <div className="basicInfo">
                                    <h3>基本信息</h3>
                                    <ul>
                                        <li>部首：{bushou}</li>
                                        <li>笔画数：{bihuaCount}</li>
                                        <li>字的结构：{structure}</li>
                                        <li>字的笔顺：{bishun}</li>
                                    </ul>
                                </div>
                                <div className="videoInfo">
                                    <h3>视频精讲</h3>
                                    {videoUrl ?
                                        <CCPlayer
                                            courseID={courseID}
                                            sectionID={sectionID}
                                            url={videoUrl}/>
                                        : <div style={{textAlign: 'center', marginTop: '20%'}}>
                                            视频加载中......
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                }
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/word_detail/WordDetail.js